import {
    tss,
} from 'app/tss'

export default tss
    .withParams<{ height?: number | string }>()
    .create(({
        theme,
    }) => {
        return {
            container: {
                width: '100%',
                '.MuiDataGrid-footerContainer': {
                    backgroundColor: theme.palette.secondary[50],
                },
                '.MuiDataGrid-main': {
                    boxShadow: 'none',
                    marginTop: 0,
                },
            },
        }
    })
